import * as React from "react";
import { RetryButton } from "../../RetryButton";
import { CustomerHistoryLink } from "./CustomerHistoryLink";
import { Text, TextVariant } from "../../../ui";

export const DeadEnd: React.FC<{
  message: string;
  onRetry?: () => Promise<unknown>;
  contactId?: string | null;
  jobId?: string | null;
}> = ({ message, onRetry, contactId, jobId }) => (
  <div className="flex flex-col items-center gap-3 p-6">
    <Text variant={TextVariant.BODY2} className="text-gray-400 text-center">
      {message}
    </Text>
    {onRetry && <RetryButton onRetry={onRetry} />}
    <CustomerHistoryLink contactId={contactId} jobId={jobId} />
  </div>
);
